import { render, staticRenderFns } from "./newsShow.vue?vue&type=template&id=bbfc3294&scoped=true&"
import script from "./newsShow.vue?vue&type=script&lang=js&"
export * from "./newsShow.vue?vue&type=script&lang=js&"
import style0 from "./newsShow.vue?vue&type=style&index=0&id=bbfc3294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfc3294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbfc3294')) {
      api.createRecord('bbfc3294', component.options)
    } else {
      api.reload('bbfc3294', component.options)
    }
    module.hot.accept("./newsShow.vue?vue&type=template&id=bbfc3294&scoped=true&", function () {
      api.rerender('bbfc3294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/myNews/newsShow.vue"
export default component.exports